import { render, staticRenderFns } from "./StateNavigationButton.vue?vue&type=template&id=42d5f670&lang=pug&"
import script from "./StateNavigationButton.vue?vue&type=script&lang=ts&"
export * from "./StateNavigationButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports